import browser from './browser';

const getBrowserWindow = (): Partial<Window> => browser.getWindow() as Partial<Window>;

// Central place for Web Crypto access so client code avoids Node crypto/polyfills.
const getWebCryptoSubtle = (): SubtleCrypto => {
  const subtleCrypto = getBrowserWindow().crypto?.subtle ?? global.crypto?.subtle;

  if (!subtleCrypto) {
    throw new Error('Web Crypto API not available in this environment.');
  }

  return subtleCrypto;
};

export default getWebCryptoSubtle;
